import React from 'react';
import styled from 'styled-components';
import { colors } from '../colors/color';
import { Flex } from '../compositeComponents/FlexHelpers';
import { css } from 'styled-components';
import { bodyColors } from '../typography/Body';

type HtmlEditorViewerProps = React.ComponentProps<'p'> & {
    content: string,
    showEditButton?: boolean,
    onClick?: () => void,
    style?: React.CSSProperties,
    small?: boolean
};
export function HtmlEditorViewer (props: HtmlEditorViewerProps): JSX.Element
{
    return (
        <Flex flexDirection="column">
            {props.onClick 
                ? <HoverableHtmlEditorViewerDiv asSmall={props.small===true} onClick={props.onClick} dangerouslySetInnerHTML={{__html:props.content}} style={props.style} />
                : <HtmlEditorViewerParagraph asSmall={props.small===true} dangerouslySetInnerHTML={{__html:props.content}} style={props.style} />
            }
        </Flex>
    )
}

type HtmlEditorViewerStyleProps = {
    asSmall: boolean,
    color?: bodyColors,
    verticalMargin?: string,
    fontSize?: string,
    variant?: 'neutral' | 'normal'
};

const common = css<HtmlEditorViewerStyleProps>`
    ${props => props.theme.styles.P}
    ${props => props.asSmall ? props.theme.styles.Small : ''}
    .ql-indent-1 { margin-left: 16px; }
    .ql-indent-2 { margin-left: 32px; }
    .ql-indent-3 { margin-left: 48px; }
    .ql-indent-4 { margin-left: 64px; }
    .ql-indent-5 { margin-left: 80px; }
    .ql-indent-6 { margin-left: 96px; }
    .ql-indent-7 { margin-left: 112px; }
    .ql-indent-8 { margin-left: 128px; }
`;


export const HtmlEditorViewerParagraph = styled.p<HtmlEditorViewerStyleProps>`
    ${common}
`;


export const HoverableHtmlEditorViewerDiv = styled.p<HtmlEditorViewerStyleProps>`
    ${common}

    &:hover {
        background-color: ${colors.background.beige};
        cursor: pointer;
    }
`;